import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
    selector: '[tartTooltipLink]',
})
export class TartTooltipLinkDirective {
    @Input() linkUrl: string;
    private tooltip: HTMLElement;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    }

    @HostListener('mouseover', ['$event'])
    onMouseOver() {
        if (this.tooltip == null) {
            // this.tooltip = this.createTooltip();
            this.renderer.appendChild(this.elementRef.nativeElement, this.tooltip);
        }
    }

    @HostListener('mouseout', ['$event'])
    onMouseOut(event) {
        if (event.relatedTarget?.tagName !== 'A' && this.tooltip != null) {
            this.renderer.removeChild(this.elementRef.nativeElement, this.tooltip);
            this.tooltip = null;
        }
    }

    // createTooltip(): HTMLElement {
    //     const tooltip = this.renderer.createElement('div');
    //     const link = this.renderer.createElement('a');
    //     link.href = this.linkUrl;
    //     link.textContent = this.linkUrl;
    //     link.setAttribute('target', '_blank');
    //     this.renderer.appendChild(tooltip, link);
    //     this.renderer.addClass(tooltip, 'tooltip-link');
    //     this.renderer.setStyle(tooltip, 'position', 'absolute');
    //     this.renderer.setStyle(tooltip, 'left', 50 + 'px');
    //     this.renderer.setStyle(tooltip, 'top',70 + 'px');
    //     return tooltip;
    // }
}
